import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[DecimalNumber]'
})

export class DecimalNumberDirective {
  @Input() decimalLimit?: any;
  @Input() integerLimit?: any;
  private regex: RegExp;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete', 'Control', 'Ctrl'];
  private lastKey: any;
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    this.regex = new RegExp(`^\\d{0,${this.integerLimit || 100}}(\\.\\d{0,${this.decimalLimit || 100}})?$`, 'g');
    if ((this.lastKey === 'Control' || this.lastKey === 'Ctrl') && (event.key === 'a' || event.key === 'A')) {
      event.target.select();
    }
    if (this.specialKeys.indexOf(event.key) !== -1) {
      this.lastKey = event.key;
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if ((this.lastKey === 'Control' || this.lastKey === 'Ctrl') &&
      (event.key === 'v' || event.key === 'V' || event.key === 'c' || event.key === 'C')) {
      return
    }
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
